import React, { useState } from "react";

import useStyles from "./css";
import { useTranslation } from "react-i18next";
import ProgressRingWithIcon from "../../../common/ProgressRingWithIcon";
import WhatsAppNotificationIcon from "../../../../assets/icons/WhatsAppNotificationIcon";
import { Color } from "../../../../constants/colors";
import ConversationCounter from "../../../../models/interfaces/conversation-counter-model";
import { ArrowDropDownIcon } from "../../../../assets/icons";


export default function NotificationFooter(props: { conversationCounter: ConversationCounter }) {
  
  const { conversationCounter } = props;
  const { monthlyConversationsLimit, spentMarketing, spentUtility, availableConversationsCount } = conversationCounter;
  
  const classes = useStyles();
  const { t } = useTranslation("general");
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  
  function getProgressRingFillPercent() {
    if (availableConversationsCount <= 0) return 0;
    const remainingPart = availableConversationsCount / monthlyConversationsLimit;
    return Math.round(remainingPart * 100);
  }
  
  const fillPercent = getProgressRingFillPercent();
  
  function getColorByFillPercent() {
    if (fillPercent <= 0) return Color.gray1;
    if (fillPercent > 50) return Color.green;
    if (fillPercent <= 25) return Color.red;
    return Color.yellow;
  }
  
  const iconColor = getColorByFillPercent();
  
  const WhatsAppIcon =
    <WhatsAppNotificationIcon
      style={{ color: iconColor, width: 32, height: 32 }}
      viewBox={"0 0 24 24"}
    />

  function handleExpanderClick(e: any) {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  }

  const ArrowIcon = <ArrowDropDownIcon style={{ color: Color.gray5, width: 12, height: 12 }} />
  
  return (
    <div className={classes.root}>
      <div className={`${classes.messagesFirstRow} ${isExpanded && classes.firstRowExpandedBorder}`}>
        <div className={classes.messagesIconContainer}>
          <ProgressRingWithIcon
            icon={WhatsAppIcon}
            fillPercent={fillPercent}
            color={iconColor}
            className={classes.messageRing}
          />
        </div>
        <div className={classes.messagesFirstRowText}>
          {`${availableConversationsCount}/${monthlyConversationsLimit} ${t("available WA conversations")}`}
        </div>
        <div
          className={classes.expander}
          onClick={handleExpanderClick}
        >
          <div
            className={`${isExpanded ? classes.upsideDown : ''}`}
          >
            {ArrowIcon}
          </div>
        </div>
      </div>
      {
        isExpanded &&
        <>
          <div className={classes.messagesText}>
            {`${t("WA marketing conversations used")}: ${spentMarketing}`}
          </div>
          <div className={classes.divider} />
          <div className={classes.messagesText}>
            {`${t("WA utility/service conversations used")}: ${spentUtility}`}
          </div>
        </>
      }
    </div>
  );
}